import {Component, EventEmitter, Output} from '@angular/core';
import {AppStateService} from '../../shared/app-state.service';
import {map} from 'rxjs/operators';

const AQ_IMAGE = require('../../../static/aquents-book-promotion/cobrand_myaquent_client_banner_aquents_book.jpg');
const AQ_URL = 'https://aquent.com/aquentsbook/preview?utm_source=myaquent&utm_medium=display&utm_campaign=AQ_US_2019_Q3_Book&utm_content=banner-iknowitwheniseeit';

@Component({
  selector: 'aquents-book-promotion',
  templateUrl: './aquents-book-promotion.component.html',
  styleUrls: ['./aquents-book-promotion.component.scss']
})
export class AquentsBookPromotionComponent {

  @Output() download = new EventEmitter<void>();

  brand$ = this.AppState.brand$;
  image$ = AQ_IMAGE;
  url$ = AQ_URL;

  constructor(private AppState: AppStateService) {
  }

}
